import { captureMessage } from '@sentry/react';

const probeKey = 'noddi-storage-probe';
const reportedKeys = new Set<string>();

const readKeySizes = (): { key: string; chars: number }[] => {
  try {
    return Array.from({ length: window.sessionStorage.length }, (_, index) => {
      const key = window.sessionStorage.key(index) ?? '';
      return { key, chars: key.length + (window.sessionStorage.getItem(key)?.length ?? 0) };
    });
  } catch {
    return [];
  }
};

const probeWrite = (): string | undefined => {
  try {
    window.sessionStorage.setItem(probeKey, '1');
    window.sessionStorage.removeItem(probeKey);
    return undefined;
  } catch (error) {
    return error instanceof Error ? error.name : String(error);
  }
};

// `storage` swallows the error of a refused write, and a console line reaches nobody. Report the
// first one per key and page load with what tells a full store (size, largest keys) from a blocked
// one (the probe's error name). Key names only, never values.
export const reportRefusedUserGroupIdWrite = (key: string) => {
  if (reportedKeys.has(key)) {
    return;
  }
  reportedKeys.add(key);

  const sizes = readKeySizes();
  captureMessage('Session storage refused a group id write', {
    level: 'warning',
    extra: {
      key,
      probeError: probeWrite(),
      keyCount: sizes.length,
      usedChars: sizes.reduce((total, size) => total + size.chars, 0),
      largestKeys: sizes.sort((a, b) => b.chars - a.chars).slice(0, 5)
    }
  });
};
